import { Bug, Lightbulb, MessageSquare } from 'lucide-react';

export const fieldStyle = 'flex flex-col mb-6';
export const labelStyle = 'font-bold block mb-1 text-gray-700';
export const inputStyle = 'w-full border-gray-300 rounded-[10px] focus:rounded-[20px]';

export const forms = [
  {
    id: 1,
    title: 'Login page not working',
    type: 'bug',
    priority: 'high',
    date: '2025-12-15',
    email: 'user@example.com',
  },
  {
    id: 2,
    title: 'Add dark mode feature',
    type: 'feature',
    priority: 'medium',
    date: '2025-12-14',
    email: 'designer@example.com',
  },
  {
    id: 3,
    title: 'Improve loading speed',
    type: 'other',
    priority: 'high',
    date: '2025-12-13',
    email: 'dev@example.com',
  },
];

export const feedbackTypes = [
  { value: 'bug', label: 'Bug Report', icon: Bug, color: 'text-red-500' },
  { value: 'feature', label: 'Feature Request', icon: Lightbulb, color: 'text-cyan-500' },
  { value: 'other', label: 'Other', icon: MessageSquare, color: 'text-amber-500' },
];
